module.exports = __webpack_public_path__ + "img/mask@3x.443232d2.webp";